<template>
  <!--================ slide =================-->
  <PageSlider></PageSlider>

  <!--================ 3 quadros categorias =================-->
  <section class="blog_categorie_area fundo-claro bt-100">
    <div v-if="listaServicos != ''" class="container">
      <div v-if="nossosServicos != ''" class="section_title text-center">
        <h2 class="title_color">{{ nossosServicos[0].itiNome }}</h2>
        <p v-html="nossosServicos[0].itiResumo1"></p>
      </div>
      <div class="row">
        <div v-for="servico in listaServicos" :key="servico.itiId" class="col-lg-4">
          <div class="categories_post">
            <router-link
              :to="'/servicosdetalhe/' + servico.itiId + '/' + formataLink(servico.itiNome + servico.itiReferencia)">
              <img :src="$imgURL + servico.insInstitucionalImagens[1].itgUrlImagem"></router-link>
            <div class="categories_details">
              <div class="categories_text">
                <router-link
                  :to="'/servicosdetalhe/' + servico.itiId + '/' + formataLink(servico.itiNome + servico.itiCampoExtra1)">
                  <h5>{{ servico.itiNome }} {{ servico.itiCampoExtra1 }}</h5>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--================ serviços =================-->

  <!--================ sobre a empresa  =================-->
  <section class="about_history_area section_gap">
    <div v-if="sobreEmpresa != ''" class="container">
      <div class="row">
        <div class="col-md-6 d_flex align-items-center">
          <div class="about_content ">
            <h2 class="title title_color">{{ sobreEmpresa[0].itiNome }}</h2>
            <p v-html="sobreEmpresa[0].itiResumo1"></p>
            <router-link :to="'/sobre/'" class="button_hover theme_btn_two">Saber mais</router-link>
          </div>
        </div>
        <div class="col-md-6 hidden-sm hidden-xs">
          <img :src="$imgURL + sobreEmpresa[0].insInstitucionalImagens[0].itgUrlImagem" class=" img-cel-sobre">
        </div>
      </div>
    </div>
  </section>
  <!--================ sobre a empresa  =================-->

  <!--================ depoimentos =================-->
  <section v-if="depoimentos != ''" class="testimonial_area section_gap">
    <div class="container">
      <div class="section_title text-center">
        <h2 class="title_color">Depoimentos</h2>
      </div>
      <div class="testimonial_slider owl-carousel">
        <Swiper :navigation="false" :pagination="{ clickable: true }" :slides-per-view="2" :space-between="40"
          :breakpoints="{ 768: { slidesPerView: 2 }, 0: { slidesPerView: 1 } }">
          <SwiperSlide v-for="depo in depoimentos" :key="depo.itiId">
            <div class="media testimonial_item">
              <img :src="$imgURL + depo.insInstitucionalImagens[0].itgUrlImagem" class="rounded-circle">
              <div>
                <p v-html="depo.itiResumo1"></p>
                <a href="#">
                  <h4 class="sec_h4">{{ depo.itiNome }}</h4>
                </a>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  </section>
  <!--================ depoimentos =================-->

  <!--=============== call to action ====================-->
  <PageCallAction></PageCallAction>

  <!--================ noticias  =================-->
  <section v-if="listaBlog.length > 0" class="latest_blog_area section_gap">
    <div class="container">
      <div class="section_title text-center">
        <h2 class="title_color">Notícias</h2>
      </div>
      <div class="row mb_30">
        <div v-for="noticia in listaBlog.slice(0, 3)" :key="noticia.itiId" class="col-lg-4 col-md-6">
          <div class="single-recent-blog-post">
            <div class="thumb card-img-avance">
              <router-link
                :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome) + (noticia.itiReferencia)" class="d-inline-block">
                <img :src="$imgURL + noticia.insInstitucionalImagens[0].itgUrlImagem"
                  class="rounded-0" alt="">
              </router-link>
            </div>
            <div class="details">
              <router-link
                :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome) + (noticia.itiReferencia)"
                class="d-inline-block">
                <h4 class="sec_h4-not">{{ noticia.itiNome }} {{ noticia.itiReferencia }}</h4>
              </router-link>
              <p>{{ resumoCurto(noticia.itiResumo1) }}</p>
              <p><strong><router-link
                    :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome) + (noticia.itiReferencia)">Leia
                    mais</router-link></strong></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--================ noticias  =================-->

</template>

<script>
import { useHead } from '@vueuse/head';
import axios from 'axios';
import PageSlider from '@/components/PageSlider.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import PageCallAction from '@/components/PageCallAction.vue';
import { useRoute } from 'vue-router';

export default {
  name: 'HomeView',
  components: {
    PageSlider,
    Swiper,
    SwiperSlide,
    PageCallAction,
  },

  data: () => ({
    listaServicos: [],
    nossosServicos: [],
    sobreEmpresa: [],
    depoimentos: [],
    listaBlog: [],
  }),

  computed: {
    primeiraNoticia() {
      return this.listaBlog.length > 0 ? [this.listaBlog[0]] : [];
    }
  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    /* resumo curto da primeira noticia */
    resumoCurto(conteudo) {
      const textoLimpo = this.removerTagsHTML(conteudo);
      const limite = 200; // você pode ajustar esse número
      return textoLimpo.length > limite ? textoLimpo.slice(0, limite) + '...' : textoLimpo;
    },

    filtraNoticia(categoria) {
      let _filtro = this.listaNoticias.filter(x => x.itiReferencia == categoria);
      this.firstNoticia = _filtro[0];
      this.otherNoticas = _filtro.slice(1, 6);
      this.finalNoticias = _filtro.slice(7);
    },

    carregaMetas(texto) {
      useHead({
        title: 'Garante Imob - Home',
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Garante Imob" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },

    toggleAccordion(index) {
      this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
    },
  },

  created() {
    this.carregaMetas("---");

    // servicos
    axios.get('/Process/InsInstitucional/institucional/46/listadeservicos/0/x')
      .then(response => {
        this.listaServicos = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const valorA = parseInt(a.itiOrdem) || 0;
          const valorB = parseInt(b.itiOrdem) || 0;
          return valorA - valorB;
        });
        //console.log('listaServicos')
        //console.log(this.listaServicos)
      })
      .catch(error => {
        console.error(error);
      });

    // textos 3 quadros categorias
    axios.get('/Process/InsInstitucional/institucional/38/conhecanossosservicos/0/x')
      .then(response => {
        this.nossosServicos = response.data;
        //console.log('nossosServicos')
        //console.log(this.nossosServicos)
      })
      .catch(error => {
        console.error(error);
      });

    // sobre empresa
    axios.get('/Process/InsInstitucional/institucional/12/textosobre/0/x')
      .then(response => {
        this.sobreEmpresa = response.data;
        //console.log('sobreEmpresa')
        //console.log(this.sobreEmpresa)
      })
      .catch(error => {
        console.error(error);
      });

    // depoimentos
    axios.get('/Process/InsInstitucional/institucional/42/depoimentos/0/x')
      .then(response => {
        this.depoimentos = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
        //console.log('depoimentos')
        //console.log(this.depoimentos)
      })
      .catch(error => {
        console.error(error);
      });

    // informações
    axios.get('/Process/InsInstitucional/institucional/36/informacoeshome/0/x')
      .then(response => {
        this.informacoesHome = response.data;
        //console.log('informações')
        //console.log(this.informacoesHome)
      })
      .catch(error => {
        console.error(error);
      });

    // notícias
    axios.get('/Process/InsInstitucional/institucional/50/noticias/0/itiData1')
      .then(response => {
        this.listaBlog = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const timeA = a.itiData1
            ? new Date(a.itiData1).getTime()
            : 0;
          const timeB = b.itiData1
            ? new Date(b.itiData1).getTime()
            : 0;
          return timeA - timeB;
        }).reverse();
        //console.log('listaBlog')
        //console.log(this.listaBlog)
      })
      .catch(error => {
        console.error(error);
      });



  },
}

</script>

<style scoped></style>
